import styled from 'styled-components';

export const Container = styled.ul`
  list-style-type: none;
`;

export const Item = styled.li`
  margin: 10px 0;
`;
